import * as React from "react";
import HandlerContext from "search-filter/contexts/HandlerContext";
import useHandlerContext from "views/components/useHandlerContext";
const HandlerContextProvider = ({ children }) => {
  const handlerContext = useHandlerContext();
  return /* @__PURE__ */ React.createElement(HandlerContext.Provider, { value: handlerContext }, children);
};
export default HandlerContextProvider;
